<template>
    <div class="attempts-indicator">
        <template v-for="n in total">
            <heart-full v-if="n <= total - used" :key="n" class="attempt-icon" />
            <heart-empty v-else :key="n" class="attempt-icon" />
        </template>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
import HeartFull from "Components/Svg/HeartFull";
import HeartEmpty from "Components/Svg/HeartEmpty";

export default {
    name : "AttemptsIndicator",

    components : { HeartFull, HeartEmpty },

    props : {
        total : { type : Number, default : 0 },
        used  : { type : Number, default : 0 }
    }
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
.attempts-indicator {
    display: flex;
    align-items: center;
    gap: 6px;

    // consumers only set the width - the hearts aren't square, so height follows
    .attempt-icon {
        display: block;
        height: auto;
    }
}
</style>
